import gql from 'graphql-tag'

export default gql`
mutation ($participantId: String! $status: String! $photo: String $descriptors: [[Float]]) {
  checkin (participantId: $participantId status: $status photo: $photo descriptors: $descriptors) {
    recordId
  }
}
`
